import { essOutgoingBatchesFactory } from '@eas/common-web';
import { ExportTags } from '@enums';

export const EssOutgoingBatches = essOutgoingBatchesFactory(
  '/api/evidence-spisu/ess/outgoing-batches',
  ExportTags.ESS_OUTGOING_BATCHES_GRID
);
